<footer class="mt-5 text-center downloadFooter">
    <div class="btn-group dropup langButton">
        <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-globe"></i> <span id="langName">{{'language' | translate}}</span>
        </button>
        <ul class="dropdown-menu">
            <li>
                <a class="dropdown-item" href="javascript:void(0)" (click)="useLanguage('en')" type="button">English</a>
            </li>
            <li>
                <a class="dropdown-item" href="javascript:void(0)" (click)="useLanguage('jp')" type="button">日本語</a>
            </li>
        </ul>
    </div>
    <!-- <div id="DigiCertClickID_UCHp2dz" style="position: absolute;right: 18px;bottom: 18px;" lang="ja"></div> -->
    <p> {{ 'powered_by' | translate }} <a href="https://www.transfercenter.jp/" target="_blank">Transfer Center</a></p>
 </footer>